import type {
  RecommendationCollects,
  ParsedRecommendationField,
} from "./types";

/**
 * Normalize a recommendation's `collects` into full field specs.
 * Bare-string shorthand: "page_description?" — "?" marks optional, the
 * name doubles as the prompt (underscores → spaces).
 */
export function parseRecommendationFields(
  collects: RecommendationCollects | undefined,
): ParsedRecommendationField[] {
  return (collects ?? []).map((raw) => {
    if (typeof raw === "string") {
      const optional = raw.endsWith("?");
      const name = optional ? raw.slice(0, -1) : raw;
      return {
        name,
        prompt: name.replace(/_/g, " "),
        optional,
        accepts: "text" as const,
        multiple: false,
      };
    }
    return {
      name: raw.field,
      prompt: raw.prompt,
      placeholder: raw.placeholder,
      optional: raw.optional ?? false,
      accepts: raw.accepts ?? "text",
      multiple: raw.multiple ?? false,
      options: raw.options,
      default: raw.default,
      fields: raw.fields?.map((sub) => ({
        name: sub.field,
        prompt: sub.prompt,
        placeholder: sub.placeholder,
        optional: sub.optional ?? false,
      })),
      itemLabel: raw.item_label,
    };
  });
}
